// extracted by mini-css-extract-plugin
module.exports = {"controls":"Check-module__controls___3g53q","controlsWrapper":"Check-module__controlsWrapper___2cVjA"};